$(document).ready(function(){
$(document).on("click", ".rebuy-product-checkbox", function () {
      var $this= $(this)
      var $productBlock = $this.closest('.rebuy-product-block');
      $productBlock.toggleClass('is-selected');
      var selectedCount = $(".rebuy-product-block.is-selected").length;
      var  selectedClass = $this.closest('.is-selected').length
      var imageId = $productBlock.find('.rebuy-bundle__image-divider .far')
       if(selectedClass == 1)
       {
            imageId.removeClass('fa-plus');
             imageId.addClass('fa-minus');
             imageId.next('span').remove();  
       }
      else
       {
          imageId.removeClass('fa-minus');
          imageId.addClass('fa-plus');
           if (!imageId.next('span').hasClass('add-text')) 
           {
                imageId.after('<span class="add-text">Add</span>');
          }
      }
    if (selectedCount === 0) {
        $(".product_page_bundle").removeClass('active-bundle-pdp');
    } else {
        $(".product_page_bundle").addClass('active-bundle-pdp');
    }
});

       setTimeout(function () {
         var selectedCount = $(".rebuy-product-block.is-selected").length;
        // $(".rebuy-bundle__image-divider .fa-plus").after('<span>Add</span>')
        if (selectedCount === 0) {
            $(".product_page_bundle").removeClass('active-bundle-pdp');
        } else {
            $(".product_page_bundle").addClass('active-bundle-pdp');
        }
      },1000);
        var checkintrvldata = setInterval(function(){
        if ($(".rebuy-bundle__image").length !== 0) {
            $(".rebuy-bundle__image-divider .fa-plus").after('<span class="add-text">Add</span>');
            var html = $(".rebuy-bundle__image-divider").prop('outerHTML');
            $(".rebuy-bundle__items").find('.rebuy-product-info').append(html);
            clearInterval(checkintrvldata); // Stop the interval
        }
    }, 300);
});
